// 日志管理相关API
import request from '@/utils/request'

/**
 * 获取日志列表 (通用分页)
 * @param {Object} params - 查询参数
 */
export async function getLogPage(params = {}) {
  try {
    const response = await request.get('/api/logs/page', { params })
    return response
  } catch (error) {
    console.error('获取日志列表失败:', error)
    throw error
  }
}

/**
 * 获取操作日志列表
 */
export async function getOperationLogs(params = {}) {
  try {
    const response = await request.get('/api/logs/operation', { params })
    return response
  } catch (error) {
    throw error
  }
}

/**
 * 获取系统日志列表
 */
export async function getSystemLogs(params = {}) {
  try {
    const response = await request.get('/api/logs/system', { params })
    return response
  } catch (error) {
    console.error('获取系统日志失败:', error)
    throw error
  }
}

/**
 * 获取安全日志列表
 */
export async function getSecurityLogs(params = {}) {
  try {
    const response = await request.get('/api/logs/security', { params })
    return response
  } catch (error) {
    console.error('获取安全日志失败:', error)
    throw error
  }
}

/**
 * 导出日志
 */
export async function exportLogs(params = {}) {
  try {
    const response = await request.get('/api/logs/export', { 
      params,
      responseType: 'blob'
    })
    return response
  } catch (error) {
    console.error('导出日志失败:', error)
    throw error
  }
}

/**
 * 获取日志详情
 */
export async function getLogDetail(id) {
  try {
    const response = await request.get(`/api/logs/${id}`)
    return response
  } catch (error) {
    console.error('获取日志详情失败:', error)
    throw error
  }
}

/**
 * 删除日志
 */
export async function deleteLog(id) {
  try {
    const response = await request.delete(`/api/logs/${id}`)
    return response
  } catch (error) {
    console.error('删除日志失败:', error)
    throw error
  }
}

/**
 * 批量删除日志
 */
export async function deleteBatchLogs(ids) {
  try {
    const response = await request.delete('/api/logs/batch', { data: ids })
    return response
  } catch (error) {
    console.error('批量删除日志失败:', error)
    throw error
  }
}

/**
 * 清空日志
 */
export async function truncateLogs() {
  try {
    const response = await request.delete('/api/logs/truncate')
    return response
  } catch (error) {
    console.error('清空日志失败:', error)
    throw error
  }
}

export default {
  getLogPage,
  getOperationLogs,
  getSystemLogs,
  getSecurityLogs,
  exportLogs,
  getLogDetail,
  deleteLog,
  deleteBatchLogs,
  truncateLogs
}
